import { Checkbox } from "antd";
import { useTranslation } from "react-i18next";
import { SearchObjectTypes } from "@/services/api/entities/search";
import type { CheckboxChangeEvent } from "antd";
import type { DebounceSearchRequest } from "../../types";
import styles from "./styles.module.scss";

type HeaderSearchOverlayControlsProps = {
  textQuery: string;
  selectedDataTypes: SearchObjectTypes[];
  setSelectedDataTypes: (dataTypes: SearchObjectTypes[]) => void;
  debounceSearch: (body: DebounceSearchRequest) => void;
  resetSearchData: () => void;
};

export const HeaderSearchOverlayControls = (props: HeaderSearchOverlayControlsProps) => {
  const { t } = useTranslation();
  const isSelected = (key: SearchObjectTypes) => {
    return props.selectedDataTypes.includes(key);
  };

  const handleChange = (e: CheckboxChangeEvent, key: SearchObjectTypes) => {
    let nextKeys = [];
    if (props.selectedDataTypes.includes(key)) {
      nextKeys = props.selectedDataTypes.filter((item: SearchObjectTypes) => item !== key);
    } else {
      nextKeys = [...props.selectedDataTypes, key];
    }

    if (nextKeys.length === 0) {
      props.resetSearchData();
    }

    props.setSelectedDataTypes(nextKeys);
    props.debounceSearch({
      textQuery: props.textQuery,
      objectTypes: nextKeys,
    });
  };

  return (
    <div className={styles.controls}>
      <Checkbox
        onChange={(e) => handleChange(e, SearchObjectTypes.PERSON)}
        checked={isSelected(SearchObjectTypes.PERSON)}
      >
        {t("search.contact")}
      </Checkbox>
      <Checkbox
        onChange={(e) => handleChange(e, SearchObjectTypes.NOTE)}
        checked={isSelected(SearchObjectTypes.NOTE)}
      >
        {t("search.note")}
      </Checkbox>
    </div>
  );
};
